import { DealDispatcherPayload, DealVoteAction } from '@pelando/components';
import { RemoveVoteVariables } from '../../../../../infra/api/votes/types/RemoveVote';
import { VoteVariables } from '../../../../../infra/api/votes/types/Vote';
import { DealActions } from './actionHandlerClickouts';

type ActionHandlerMutationsParams = {
  action: DealActions;
  onVote: (variables: VoteVariables) => void;
  onRemoveVote: (variables: RemoveVoteVariables) => void;
};

export const actionHandlerMutations = ({
  action,
  onVote,
  onRemoveVote,
}: ActionHandlerMutationsParams) => {
  switch (action.type) {
    case DealVoteAction.VOTE:
      onVote(action.payload as DealDispatcherPayload<DealVoteAction.VOTE>);

      break;

    case DealVoteAction.REMOVE_VOTE:
      onRemoveVote(
        action.payload as DealDispatcherPayload<DealVoteAction.REMOVE_VOTE>
      );

      break;

    default:
      break;
  }
};
